<div class="wizard-container container"
     [ngClass]="'wizard-' + wizard.key"
  [ngStyle]="{
       width: wizard.width + 'px', 
       'min-width': wizard.width + 'px', 
       'max-width': wizard.width + 'px',
       'background-color': wizard.backgroundColor || null,
       'height': wizard.height || null,
       'max-height': wizard.maxHeight || null
     }">

  <div class="header-container" fxLayout="row" fxLayoutAlign="start center" *ngIf="isInitialized && !wizard.hideHeader">
    <div>
      <h2 class="mat-h2 wizard-heading" fxLayoutGap="10px" [ngClass]="wizard?.model?.location ? 'align-center-title' : ''" mat-dialog-title
        fxLayout="row" fxLayoutAlign="start center"
        mat-dialog-title
        [innerHTML]="(wizard.currentPage?.title || ('WIZARD.LOADING' | translate)) | safeHtml">
      </h2>
      <div *ngIf="!!wizard.currentPage?.subTitle"><small>{{ wizard.currentPage?.subTitle }}</small></div>
    </div>
    <div fxFlex></div>
    <div *ngIf="wizard.currentPage?.exportButtonText">
      <button [disabled]="!wizard.currentPage?.exportButton"
        [matTooltip]="!wizard.currentPage?.exportButton ? wizard.currentPage?.exportButtonDisableText  : ''"
        [color]="wizard.currentPage?.actionButtonColor" mat-raised-button (click)="exportData()">
        <span>{{ wizard.currentPage?.exportButtonText }}</span>
      </button>
    </div>
    <div *ngIf="wizard.currentPage?.chartAndTableToggle" class="view-toggle">
      <div class="toggle-container">
        <div class="toggle-button " [ngClass]="{'active': !ischartView}" (click)="ischartView ? toggleView('table') : null">
          <svg class="grid-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" matTooltip="Table View" matTooltipPosition="above">
            <path d="M1.64795 6.98611H11.5772M6.61257 2.02148V11.9507M4.29575 2.02148H8.9294C9.85622 2.02148 10.3196 2.02148 10.6736 2.20186C10.985 2.36051 11.2382 2.61368 11.3968 2.92506C11.5772 3.27906 11.5772 3.74247 11.5772 4.66929V9.30294C11.5772 10.2298 11.5772 10.6932 11.3968 11.0472C11.2382 11.3585 10.985 11.6117 10.6736 11.7704C10.3196 11.9507 9.85622 11.9507 8.9294 11.9507H4.29575C3.36893 11.9507 2.90552 11.9507 2.55153 11.7704C2.24014 11.6117 1.98698 11.3585 1.82832 11.0472C1.64795 10.6932 1.64795 10.2298 1.64795 9.30294V4.66928C1.64795 3.74247 1.64795 3.27906 1.82832 2.92506C1.98698 2.61368 2.24014 2.36051 2.55153 2.20186C2.90552 2.02148 3.36893 2.02148 4.29575 2.02148Z" stroke="white" stroke-width="1.10325" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="toggle-button" [ngClass]="{'active': ischartView}" (click)="!ischartView ? toggleView('chart') : null">
          <svg class="chart-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" matTooltip="Chart View" matTooltipPosition="above">
            <path d="M11.8853 11.9273H3.7594C3.14441 11.9273 2.83691 11.9273 2.60201 11.8076C2.39539 11.7023 2.22741 11.5343 2.12213 11.3277C2.00244 11.0928 2.00244 10.7853 2.00244 10.1703V2.04437M4.19864 6.16225V10.0056M6.66937 3.417V10.0056M9.14009 6.16225V10.0056M11.6108 3.417V10.0056" stroke="white" stroke-width="1.0981" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
    <div *ngIf="wizard.currentPage?.exportPdfButtonText" class="ml-10">
      <button [disabled]="!wizard.currentPage?.exportPdfButton"
        [color]="wizard.currentPage?.actionButtonColor" mat-raised-button (click)="exportPdf()">
        <fa-icon icon="file-pdf"></fa-icon>
        <span class="ml-5">{{ wizard.currentPage?.exportPdfButtonText }}</span>
      </button>
    </div>
    <button mat-icon-button (click)="wizard.model?.isCrossButtonEvent ? crossButtonEvent() : close()"
      [hidden]="!wizard.currentPage?.closeButtonText">
      <fa-icon icon="times"></fa-icon>
    </button>
  </div>

  <div class="loader-container" *ngIf="!isInitialized" fxLayoutAlign="center center">
    <img src="assets/images/cube-preloader.svg" height="90px" width="90px;"
      alt="{{ 'WIZARD.LOADING_ALT' | translate }}" />
  </div>

  <div class="content-container container scrollable" fxLayout="column" fxLayoutGap="15px" [hidden]="!isInitialized">
    <mtn-wizard-stepper [wizard]="wizard" *ngIf="isInitialized && wizard.pageCount > 1"></mtn-wizard-stepper>

    <div class="content-header-container" *ngIf="wizard.currentPage?.headerText || wizard.currentPage?.subheaderText">
      <h2 class="mat-h2 color-primary no-bottom-margin" *ngIf="wizard.currentPage?.headerText">{{
        wizard.currentPage?.headerText }}</h2>
      <div *ngIf="wizard.currentPage?.subheaderText" [innerHTML]="wizard.currentPage?.subheaderText"></div>
    </div>

    <mtn-simple-panel color="purple" *ngIf="wizard.currentPage?.alert1Text">
      <div [innerHTML]="wizard.currentPage?.alert1Text "></div>
    </mtn-simple-panel>

    <form (ngSubmit)="next()">
      <div #page></div>
    </form>

    <mtn-simple-panel color="purple" *ngIf="wizard.currentPage?.alert2Text">
      <div [innerHTML]="wizard.currentPage?.alert2Text "></div>
    </mtn-simple-panel>

  </div>

  <div class="footer-container" fxLayout="row" *ngIf="isInitialized && !wizard.hideFooter">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="footer" *ngIf="wizard.currentPage?.footerText" [innerHTML]="wizard.currentPage?.footerText "></div>
    </div>

    <div fxFlex></div>

    <div class="wizard-toolbar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
      <!-- Footer Checkbox -->
      <div *ngIf="wizard.currentPage?.doNotShowAgainCheckbox">
        <mat-checkbox color="primary" [(ngModel)]="wizard.doNotShowAgainCheckboxChecked"
          (change)="onCheckboxChange($event.checked)">
          {{ wizard.currentPage?.doNotShowAgainCheckbox }}
        </mat-checkbox>

      </div>

      <!-- Action Button -->
      <div class="mr-15" [hidden]="!wizard.currentPage?.actionButtonText" mtnClickTrap>
        <button mat-raised-button [color]="wizard.currentPage?.actionButtonColor" (click)="action()"
          [disabled]="!wizard.currentPage || !wizard.currentPage.isActionButtonEnabled">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <fa-icon [icon]="wizard.currentPage?.actionButtonIcon" *ngIf="wizard.currentPage?.actionButtonIcon"
              [ngStyle]="{'font-size': wizard.currentPage?.actionButtonIconSize + 'px'}"></fa-icon>
            <span>{{ wizard.currentPage?.actionButtonText }}</span>
          </div>
          <mtn-spinner [hidden]="wizard.model?.hideActionSpinner" [color]="wizard.currentPage?.actionButtonColor"
            [size]="SpinnerSize.EXTRA_SMALL" #actionSpinner></mtn-spinner>
        </button>
      </div>

      <!-- Back Button -->
      <div [hidden]="!wizard.currentPage?.backButtonText">
        <button mat-raised-button (click)="back()">
          <mtn-spinner [size]="SpinnerSize.EXTRA_SMALL" #backSpinner></mtn-spinner>
          <span>{{ wizard.currentPage?.backButtonText }}</span>
        </button>
      </div>

      <!-- Next Button -->
      <div [mtnFormErrorHighlighter]="wizard.currentPage?.form" [hidden]="!wizard.currentPage?.nextButtonText">
        <button [color]="wizard.currentPage?.nextButtonColor" mat-raised-button (click)="next()"
          [disabled]="!wizard.currentPage?.form?.valid">
          <mtn-spinner [color]="wizard.currentPage?.nextButtonColor" [size]="SpinnerSize.EXTRA_SMALL"
            #nextSpinner></mtn-spinner>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <fa-icon [icon]="wizard.currentPage?.nextButtonIcon" *ngIf="wizard.currentPage?.nextButtonIcon"
              [ngStyle]="{'font-size': wizard.currentPage?.nextButtonIconSize + 'px'}"></fa-icon>
            <span>{{ wizard.currentPage?.nextButtonText }}</span>
          </div>
        </button>
      </div>

      <!-- Close Button -->
      <div [hidden]="!wizard.currentPage?.closeButtonText">
        <button mat-raised-button (click)="close()">
          <mtn-spinner [size]="SpinnerSize.EXTRA_SMALL" #closeSpinner></mtn-spinner>
          <span>{{ wizard.currentPage?.closeButtonText }}</span>
        </button>
      </div>
    </div>
  </div>
</div>